import { render, staticRenderFns } from "./ProfileApp.vue?vue&type=template&id=3b53a712&scoped=true"
import script from "./ProfileApp.vue?vue&type=script&lang=js"
export * from "./ProfileApp.vue?vue&type=script&lang=js"
import style0 from "./ProfileApp.vue?vue&type=style&index=0&id=3b53a712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b53a712",
  null
  
)

export default component.exports